// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inactive-program-dialog__content-container{padding:20px 15px 85px}", ""]);
// Exports
module.exports = exports;
